import React from 'react'
import { string } from 'prop-types'
import { MediaIframeEmbed } from '../MediaIframeEmbed'
import getVideoId from 'get-video-id'

export const YoutubeExtract = ({ channel, ...rest }) => {
  if (!channel) return null
  const id = getVideoId(channel)?.id

  return <MediaIframeEmbed src={`https://www.youtube.com/embed/${id}`} {...rest} />
}

YoutubeExtract.propTypes = {
  channel: string,
}
